export enum SurveyTemplate {
  SoftSkillAssessment = 'Soft skills',
  HardSkillAssessment = 'Hard skills',
}
